import { render } from "./CommentVoteButtons.vue?vue&type=template&id=f1695cde"
import script from "./CommentVoteButtons.vue?vue&type=script&lang=js"
export * from "./CommentVoteButtons.vue?vue&type=script&lang=js"

import "./CommentVoteButtons.vue?vue&type=style&index=0&id=f1695cde&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__